import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppResponse } from '@data/app/response';
import { environment } from '@environments/environment';
import { ApiPaths } from '@mpg-core/constants/api-paths.enum';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ManageUsersService {

  constructor(private http: HttpClient){}
  searchBySpeIdIDM(id:string): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.searchIDMUserDetailsByUserId+ "/" + id).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }
  checkPsrGroup(id:number): Observable<any> {
    
    return this.http.get<any>(environment.apiUrl+ ApiPaths.checkIfUserIsAssociatedToPsrGroup + "/" + id).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  getManageUsers(): Observable<any> {
    return this.http.get<any>(environment.apiUrl+ ApiPaths.getAllActiveUsers).pipe(
      map((res: AppResponse) => {
        return res;
      })
    );
  }

  deletUser(id:number){
      let params = new HttpParams()
        .set('userId', id);
      return this.http.delete<any>(environment.apiUrl+ ApiPaths.deleteUser,{params}).pipe(
        map((res: AppResponse) => {
          return res;
        })
      );
    }

    saveUser(payload:any): Observable<any> {
      return this.http.post<any>(environment.apiUrl+ ApiPaths.saveUser, payload ).pipe(
        map((res: AppResponse) => {
          return res;
        })
      );
    }

    getRoles(){
      return this.http.get<any>(environment.apiUrl+ ApiPaths.getRoles).pipe(
        map((res: AppResponse) => {
          return res;
        })
      );
    }

    getDepartments(){
      
      return this.http.get<any>(environment.apiUrl+ ApiPaths.getPicklistByCategoryId + 21).pipe(
        map((res: AppResponse) => {
          return res;
        })
      );
    }

}
